export const css = {
	root: '_3hVJXmMX',
	' _key': 'afcpe-theme/afcpe/micro/backview/backview'
};

export default css;
